/**
 * Checks if the current iOS version is at or below the specified threshold.
 *
 * This function detects iOS devices and compares their version against a specified
 * major version threshold. It returns true if the iOS version is
 * below or equal to the threshold, false otherwise.
 *
 * @param {number} [majorThreshold=16] - The major version threshold to compare against
 * @returns {boolean} - Returns true if the iOS version is at or below the threshold, false otherwise
 */
export const isIOSVersionOrBelow = (majorThreshold = 16) => {
  const ua = navigator.userAgent;

  // Only proceed if it's an iPhone, iPad
  if (!/iP(hone|ad)/.test(ua)) return false;

  // Extract iOS version from user agent
  const match = ua.match(/OS (\d+)_?/);
  if (!match) return false;

  const major = parseInt(match[1], 10);

  return major <= majorThreshold;
};

export const isIphone = () => {
  return /iPhone/.test(navigator.userAgent) && !window.MSStream;
};
